import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IntegrationDetails } from '@pdqdev/pdq-shared/dist/entities';
import { IntegrationsService } from '@services/integrations/integrations.service';

@Component({
  selector: 'integration-item',
  templateUrl: './integration-item.component.html',
  styleUrls: ['./integration-item.component.scss'],
  standalone: false,
})
export class IntegrationItemComponent implements OnInit, OnChanges {
  @Input() integration: IntegrationDetails;
  @Input() disabled: boolean = false;
  logoUrl: string;
  description: string;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) {}
  ngOnInit(): void {
    this.initDetails();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.integration) {
      this.initDetails();
    }
  }
  private initDetails() {
    const typeName = this.integration?.type?.name;
    const descriptionEl = Array.isArray(this.integration.type?.description)
      ? this.integration.type?.description?.find((element) => element.title === 'Description')
      : null;
    this.description = descriptionEl?.content ? (descriptionEl.content as string) : '';
    this.logoUrl = IntegrationsService.getLogoUrl(typeName);
  }

  handleIntegrationClick(id: string | number) {
    this.router.navigate(['./', `${id}`], { relativeTo: this.route });
  }
}
